document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // Product page thumbnail swap
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-section__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (mainImage && full) mainImage.setAttribute('src', full);
    });
  });
    // Variant switcher – uppdatera pris och variant-ID
  var variantSelects = document.querySelectorAll('.product-section__option select');
  var priceEl = document.querySelector('.product-section__price');
  var variantIdInput = document.querySelector('input[name="id"]');
  var addToCartBtn = document.querySelector('.btn--full');

  function getSelectedVariant() {
    var selectedOptions = Array.from(variantSelects).map(function(s) { return s.value; });
    return (window.productVariants || []).find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr';
  }

  variantSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      var variant = getSelectedVariant();
      if (!variant) return;
      if (priceEl) priceEl.firstChild.textContent = formatMoney(variant.price) + ' ';
      if (variantIdInput) variantIdInput.value = variant.id;
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'LÄGG I VARUKORG' : 'SLUTSÅLD';
      }
    });
  });

});
